import { IStore } from "helpers";
import { createSlice } from "@reduxjs/toolkit";

export const historyQueryReducer = createSlice({
  name: "history queries store",
  initialState: {
    lotPricingListFilter: {},
    killLineApiLogsFilter: {},
  },
  reducers: {
    setLotPricingListFilter: (state, action) => {
      state.lotPricingListFilter = action.payload;
    },
    setKillLineApiLogsFilter: (state, action) => {
      state.killLineApiLogsFilter = action.payload;
    },
    clearHistoryQueries: (state) => {
      state.lotPricingListFilter = {};
      state.killLineApiLogsFilter = {};
    },
  },
});
export const { setLotPricingListFilter, setKillLineApiLogsFilter, clearHistoryQueries } = historyQueryReducer.actions;

export const getLotPricingListFilter = (state: IStore) => state.historyQuery;

export default historyQueryReducer.reducer;
